<div class="popup-content">
  <div class="heading-part">
    <div class="heading-part-left">
      <h1>Comments</h1>
      <p class="new-text">{{ commentCounts || 0 }}</p>
    </div>
    <span class="close" (click)="onClose()" [innerHTML]="ICONS.closeCircleIcon | safeHtml"></span>
  </div>
  <div class="list_hight">
    <app-comment-box
      [DetailsFeed]="DetailsFeed"
      [page]="'commentFeed'"
      (commentCount)="postCount(); reload = true"
      (closeBox)="onClose()"
    ></app-comment-box>
  </div>
</div>
